module.exports = __webpack_public_path__ + "static/img/viewing_duration_prompt.b8823e46.png";